import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Projects', href: '#projects' },
    { name: 'About', href: '#about' },
    { name: 'Process', href: '#process' },
    { name: 'Lab', href: '#lab' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <>
      <motion.nav 
        initial={{ y: -100 }} 
        animate={{ y: 0 }} 
        className={`fixed top-0 left-0 right-0 z-[110] transition-all duration-300 border-b ${scrolled || isMenuOpen ? 'bg-obsidian/95 backdrop-blur-md border-white/10 py-4' : 'bg-transparent border-transparent py-6'}`}
      >
        <div className="container mx-auto px-6 flex items-center justify-between">
          <a href="#" className="group relative z-[110]">
            <div className="font-orbitron font-bold text-lg md:text-xl tracking-widest text-white group-hover:text-neon-cyan transition-colors">
              MIDNIGHTNEURON<span className="text-neon-cyan">.COM</span>
            </div>
          </a>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <a key={link.name} href={link.href} className="relative text-sm font-mono text-dim-white hover:text-white uppercase tracking-wider transition-colors group">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-neon-cyan group-hover:w-full transition-all duration-300"></span>
              </a>
            ))}
            <a href="#contact" className="px-4 py-2 border border-neon-cyan/30 text-neon-cyan font-mono text-xs hover:bg-neon-cyan/10 transition-colors uppercase tracking-widest">
              Start Build
            </a>
          </div>

          <button className="md:hidden text-white z-[120] p-2" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <SafeIcon icon={isMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} className="text-2xl" />
          </button>
        </div>
      </motion.nav>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.div 
            initial={{ opacity: 0, x: '100%' }} 
            animate={{ opacity: 1, x: 0 }} 
            exit={{ opacity: 0, x: '100%' }} 
            className="fixed inset-0 bg-obsidian z-[105] flex flex-col pt-24 px-6 md:hidden"
          >
            {navLinks.map((link, i) => (
              <motion.a 
                initial={{ opacity: 0, x: 20 }} 
                animate={{ opacity: 1, x: 0 }} 
                transition={{ delay: 0.1 + (i * 0.1) }}
                key={link.name} 
                href={link.href} 
                onClick={() => setIsMenuOpen(false)}
                className="text-4xl font-orbitron font-bold text-white hover:text-neon-cyan transition-colors py-4 border-b border-white/5 flex justify-between items-center group"
              >
                <span>{link.name}</span>
                <SafeIcon icon={FiIcons.FiArrowRight} className="text-neon-cyan opacity-0 group-hover:opacity-100 transition-opacity" />
              </motion.a>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navbar;